import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters.js";
import CONSTNAME from "@/ConstName.js";

function createStore() {
  const store = new Vuex.Store(
    {
      state: {
        // ========多语言字段集合·仅控件初始化时候赋值========
        langMap: {
          dragErrorMsg: "目标行无效，请重新选择释放横道位置。",
          timeExceedMsg: "时间标尺（时）的时间范围不能大于一年的数据设置，请调整时间范围后重试。",
          ganttName: "时间标尺（时）的时间范围不能大于一年的数据设置，请调整时间范围后重试。",
          dayOption: "日",
          hourOption: "时",
          weekOption: "周",
          monthOption: "月",
          cellScaleText: "数据比例:",
          realCellScaleText: "当前比例:",
          cellWidthText: "基准宽度:",
          setScaleText: "设置比例",
          magnifyText: "放大",
          shrinkText: "缩小",
          printText: "打印",
          batchSelectText: "批量选中",
          timelineText: "请选择时间轴二级单位",
          newScaleText: "请输入新设定比例,10<=number<=1000",
          startSearchText: "开始搜索",
          preSearchText: "搜索·上一个",
          nextSearchText: "搜索·下一个",
          closeSearchText: "关闭搜索",
        },

        uuid: "", // 控件ID【pageId_key】
        dataLoadingStatus: !false, // 控件数据加载态
        stayInPlace: false, // 刷新是否需要回顶部
        /* 配置项*/
        accessLevel: 1, // 默认1 其他缺少权限的大于1
        ganttWidth: window.innerWidth, // 甘特图组件最外层盒子总宽
        ganttHeight: window.innerHeight, // 甘特图组件最外层盒子总高
        initTableWidth: 200, // 左侧表格窗口宽度 --能调整-初始属性计算得出 || 配置
        initTableWidthFlag: "config", // 需要调整initTableWidth前设为 config | auto | ignore
        cellWidth: 25, // 单元格宽度: 同步修改此处和less中 @cellWidth
        cellScale: 1, // 单元格缩放比例系数
        cellUnitType: "day", // 单元格最小时间类型day hour week month
        /** 视图整体高度设置 ———— 不可用户操作 */
        timesLineHeight: 25, // 甘特图头部时间轴的单行高度和wbs头一半的高度: 同步修改此处和less中 @timesLineHeight可自动调整表头部整体占高
        cellHeight: 50, // 横道区·单元行高: 同步修改此处和less中 @cellHeight可自动调整 36(横道20+16文字描述一 居于上下俩大行横道之间) 16+12   32是地板
        summaryCellHeight: 18, // 统计区行高: 同步修改此处和less中 @summaryCellHeight可自动调整 36 18
        taskHeight: 20, // 横道高度: 同步修改此处和less中 @taskHeight可自动调整 20 16
        /** 视图整体横向显示模式 ———— 可用户操作 */
        showMode: "both", // 展现形式 both right
        noTree: false, // 不展示树
        treeWidth: 300, // WBS树宽
        /* 视图色系 */
        theme: "#5582f3", // 主题色系（默认图标,*视图切换按钮*,当日线）

        selectTaskIndex: -1, // 选中的任务行·底色展示
        /* 连接指示虚线*/
        dashDeg: 0, // 初始虚线旋转角度  默认位置竖直向下为0°
        dashHeight: 0, // 初始虚线高度
        dashPosTop: 0, // 初始虚线位置 距顶
        dashPosLeft: 0, // 初始虚线位置 距左
        moveLinkFlag: false,
        ganttType: CONSTNAME.PLANS,
        // 打印状态
        printStatus: false,
        printDebug: false, // 测试查看打印图片
        isDragging: false, // 拖拽状态
        guideYAxis: null, // 拖拽指示线


        searchedActNum: 0, // 搜索结果·当前显示的横道下标值

        // 公共·视图方案信息【res-viewSchem】
        viewSchem: {
          cellScale: 1, // 时间单元格比例
          cellUnitType: "day", // 单元格最小时间类型day hour
          // ganttWidth: null, // 初始化组件总宽{Number}
          start: 1604332800000, // "2020-11-20", // 总体任务设置的起点【 '2020-11-20', 1604188800000 ,undefined默认当天】
          end: 1609257600000, // "2020-12-20", // 总体任务设置的终点
          ganttName: "名称", // wbs树表头
          ganttNums: 1, // 单页签甘特图控件数量
          ganttHeadShow: true, // 是否显示甘特图表头
          highlightColor: "#606266", // 高亮颜色值
          isZebraStripes: false, // 是否斑马纹
          // 节假日配置
          holiday: {
            enable: false,
            day: [], // 固定频率:周几集合 0 - 7
            spcDay: [], // "05-01" "10-01" ···
            colorMap: {
              // "08-01": "yellow",
            },
          },
          todoShow: false, // 是否显示待排区
          summaryShow: false, // 是否显示统计区
          // 水平+竖直背景分割线
          otherSet: {
            hline: {
              otherAssishlinetype: "solid",
              otherInternalcol: 0,
              otherShowhline: false,
            },
            lline: {
              otherAssislinetype: "solid",
              otherInternalrow: 0,
              otherShowlvlline: false,
            },
            otherFirstrule: "",
            otherId: "",
            otherSecondrule: "",
          },
          initTableWidthFlag: "auto", // 需要调整initTableWidth前设为 config | auto | ignore, config 取initTableWidth宽度 auto计算  ignore忽略---代码用外层的字段无直接使用
          initTableWidth: 200, // 搭配initTableWidthFlag---代码用外层的字段无直接使用
          showMode: "both", // 初始化显示模式
          treeWidth: 200, // 树宽

          isLineShow: true, // 连线关系·计划区内是否显示
          isLineShowType: 1, // 连线显示模式类型 老版1 新版2
          timelineShowRows: 2, // 时间轴内容显示几级(getters取值)
          isIndexMode: false, //  时间轴顺序显示***仅显示序号一级·与其他配置项互斥***
          isRankMode: false, // 时间轴排序显示·第三栏优先级1
          rankStart: undefined, // 排序起点
          isWeekCodeMode: false, // 时间轴周几首字母显示·第三栏优先级2
          isVerticalMode: false, // 时间轴二级竖型显示
          emptyBarsShow: false, // 是否显示空白横道
          normalBarsShow: true, // 是否显示正常横道·矩形全类
          taskFilter3: false, // 横道显示筛选·是否显示关键路径横道
          taskFilter6: false, // 横道显示筛选·是否显示二级关键路径横道
          noTaskBorderRadiusShow: false, // 普通横道不显示圆角
          isTaskBorderShow: false, // 常规任务横道是否显示黑色边框
          isRowCheckBoxShow: true, // 表单行是否显示勾选框
          isRowIconShow: true, // 表单行是否显示名称前置图标
          dropTargetType: 1, // 1:横道 2:人员班组之类外部其他控件的
          isDropYAxisShow: false, // 是否显示拖拽垂直标尺辅助线
          timelineFillType: 1, // 横向单元格填充模式 1: 数量填充, 2: 放大填充, 3: 不填充(cellScale), 4:打印比例填充,
          tableLineAdjustable: true, // 表格列是否支持调整
          weekedBgShow: false, // 非工作日背景色显示
          treeFontSize: 12, // 树结构显示 字体大小 ===
          treeFontWeight: "", // 树结构显示·字体加粗 ===
          noGanttOutBoxBorder: false, // 无甘特图外边框 ===
          isBarSelectRow: false, // 选择横道是否选中所属行
          isPrintModeShow: false, // 是否打印显示模式(不限高·平铺计划区)
          printMaxScale: 2, // 打印质量最大缩放比例
          printModeWidth: 500, // 打印预览模式尺寸比·宽
          printModeHeight: 700, // 打印预览模式尺寸比·高
          barsFontSize: 12, // 巴条标签文字大小
          timelineWeekCodeShowNums: 1, // 时间轴周字母显示数量 (1: 默认首字母, 3:前3位字母, 10:全英文)[通常用1 2 3 4内较常规]
          timeLineFontNomal: false, // 时间轴字体大小正常显示(非加粗)
          timesLineHeight: 25, // 时间轴·单行行高
          cellRowHeight: 50, // 横道区·单元行高
          timelineFontSize: 12, // 时间轴·字体大小
          timelineBgDates: [], // 展示背景色日期·集合  子项格式"YYYY-MM-DD"
          timelineBgDatesColor: "rgba(0,0,0,0.3)", // 展示背景色日期·背景颜色值

          /* 本地 */
          searchedList: [ // 搜索结果·横道集合
            /* {
              startDate: 1641433095000, // 必需项: 开始时间
              endDate: 1657109794264, // 必需项: 结束时间
              groupId: "8113434303280661871&1455207762614124544", // 必需项: 所属行ID
              curRow: 1, // 必需项: 所处子行数
              // 其他横道对象冗余字段
            }, */
          ],
          virtualStartNum: CONSTNAME.VIRTUAL_START_NUM, // 虚拟阀值·弃用

          /* 样式 */
          linkLineColor: "#ec9f2c", // 连线
          borderColor: "#666666", // y轴
          borderXColor: "#666666", // x轴
          

          /* 后端冗余 */
          viewID: "", // 视图ID
          viewNumber: "", // 视图编码
          viewName: "", // 视图名称
        },
        // 公共·WBS数组-表头【res-columns】
        wbsHeaderArr: [],

        [CONSTNAME.PLANS + "_wbsRowArr"]: [ // 主分区·WBS数组-表体【res-pageData-dataList】 原wbsRowArr
          /* {
            "cellList": [], // 表单内容
            "isExpand": true, // 是否展开
            "level": 1, // 树形层级
            "isSelect": false, // 前端无用-后端释义
            "pid": "", // 上级ID
            "name": "待排大组", // 显示名称
            "id": "dp-0", // 唯一ID
            "isSealf": false, // 是否叶子节点-不带折叠标
            "dropable": false, // 是否允许拖放
            "entityFlagIndex": 1, // 行图标类型
            "entityFlagColor": "red", // 行图标颜色
            "entityFlagIndex1": 1, // 行图标类型1
            "entityFlagColor1": "red", // 行图标颜色1
            "entityFlagIndex2": 1, // 行图标类型2
            "entityFlagColor2": "red", // 行图标颜色2
            "entityFlagIndex3": 1, // 行图标类型3  新增了额外3个
             "entityFlagColor3": "red", // 行图标颜色3
            "menus": [ // 注册右键菜单
              {
                cbName: "查看任务", // 展示名称
                cbNumber: "barClickGtList", // 调用编码
                disabled: false, // 是否可点击
              },
            ],
            "ganttType": CONSTNAME.TODOS, // 数据源类型
            "rowType": "2", // 纯描述文字WBS树名称显示行 优先级1  默认是1或者空则为标准展示表格 优先级2
            "rowCount": 1 // 当前大行·子行数量
          }, */
        ],
        [CONSTNAME.PLANS + "_emptyTasksArr"]: [], // 空横道集合
        [CONSTNAME.PLANS + "_tasksArr"]: [ // 主分区·任务数组【res-pageData-taskDataList】 原tasksArr
          /* {
            "groupId": "dp-1", // 横道所属大行ID
            "taskId": "dp-t-1", // 横道唯一ID
            "crossId": "1183857321042774019", // 横道样式ID key
            "taskLink": [ // 连线关系集合
              {
                taskId: "dp-t-1", // 自身横道ID
                taskLinkId: "dp-t-2", // 连接方横道ID
                startLinePosType: "pre", // 起点连接类型
                endLinePosType: "next", // 终点连接类型
              },
            ],
            "startDate": 1625068800000 + 86400000 * -3, // 开始时间
            "endDate": 1625241599000 + 86400000 * -3, // 结束时间
            "desc": "待排任务1", // 图标显示文案
            "draggable": true, // 是否允许拖拽
            "adjustable": true, // 是否允许左右单点调整
            "barColor": "#8071a6", // 横道显示颜色
            "ganttType": CONSTNAME.TODOS, // 数据来源类型
            "curRow": 1, // 所处大行中的子行数
            "taskListIndex": 0,
            "menus": [ // 注册菜单
              {
                cbName: "查看任务", // 展示名称
                cbNumber: "barClickGtList", // 调用编码
                disabled: false, // 是否可点击
              },
            ],
            "labelIsShow": false, // 行内外文案显示总开关
            "innerDesc": "行内文案描述",
            "leftDesc": "", // 行外左侧文案描述,
            "rightDesc": "", // 行外右侧文案描述,
            "botDesc": "", // 行外下侧文案描述,
            "crossObj": 2, // 横道大类(1:任务 2:里程碑 3:关键路径 4:汇总 5:空闲 6:二级关键路径) 3和6可控制切换显示
            "crossObjName": "group",
            "isDashedBar": true, // 虚横道·是否显示
            "dashedStartDate": 1624809600000, // 虚横道·起点时间戳
            "dashedEndDate": 1624896000000, // 虚横道·终点时间戳
            descIconList: [  // 行外描述文字·前面图标集合 值为 字符串(苍穹类名) || 字符串(图片网络地址·有加载不出的风险) || 数字(映射本地图标集合内值)
              {
                type: "url", // ["platform", "url", "local"]
                val: "https://xxx/xxx/abc.png" // ["kdfont kdfont-cebianlantubiao6beifen", "https://xxx.kingdee.com/xxx/abc.png", 0-5数字下标]
              }
            ],
            "leftDrag": true, // 在adjustable之下单独控制左侧 实际横道false
            "showPercent": false, // 是否显示计算后的百分比率 实际横道true
            "planDateTimeStamp": 1234543323, // 计算百分比的除数
            "isHide": false, // 单横道隐藏
            "dblclickBarStatus": false, // 是否开启双击巴条交互
            "dblclickBarAction": "", // 双击巴条交互·名称(服务端提供并接收处理响应)
            "isLine": true, // 是否可连线操作
          }, */
        ],
        [CONSTNAME.PLANS + "_yLines"]: // 主分区·垂直线集合【res-pageData-yLines】
        [
          /* {
            time: 1624809600000 + 86400000 * 1,
            color: "#ff0505",
            type: "solid",
            width: 2,
          }, */
        ],
        [CONSTNAME.PLANS + "_map"]: null,
        // [CONSTNAME.PLANS + "_height"]: "", // 保持字段一致·暂无实际用处
        [CONSTNAME.PLANS + "_noUpdatePosition"]: false, // 是否不更新二次计算的行位置信息·提升性能
        [CONSTNAME.PLANS + "_selectedArr"]: [], // 选中项ID
        [CONSTNAME.PLANS + "_highlightType"]: "default", // 区域高亮类型(字符串 与自身类型对比展示)
        [CONSTNAME.PLANS + "_dashedBar"]: { // 虚横道
          "show": false,
          "css": {
            "left": "0px",
            "top": "0px",
            "width": "0px",
            "height": "0px",
            "border-color": "red",
          },
        },
        [CONSTNAME.PLANS + "_hasNext"]: false, // 是否有更多加载内容

        /* 待排区 */
        todoShow: false, // 显示开关
        [CONSTNAME.TODOS + "_rowsNum"]: 4, // 视口显示行数
        [CONSTNAME.TODOS + "_wbsRowArr"]: [],
        [CONSTNAME.TODOS + "_emptyTasksArr"]: [], // 空横道集合·除计划区外其他区暂未启用
        [CONSTNAME.TODOS + "_tasksArr"]: [],
        [CONSTNAME.TODOS + "_yLines"]: [],
        [CONSTNAME.TODOS + "_map"]: null,
        // [CONSTNAME.TODOS + "_height"]: "", // 保持字段一致··暂无实际用处 用_rowsNum替换
        [CONSTNAME.TODOS + "_noUpdatePosition"]: false,
        [CONSTNAME.TODOS + "_selectedArr"]: [],
        [CONSTNAME.TODOS + "_highlightType"]: "",
        [CONSTNAME.TODOS + "_dashedBar"]: {
          "show": false,
          "css": {
            "left": "0px",
            "top": "0px",
            "width": "0px",
            "height": "0px",
            "border-color": "red",
          },
        },
        [CONSTNAME.TODOS + "_hasNext"]: false,

        /* 统计区 */
        summaryShow: false, // 显示开关
        [CONSTNAME.SUMMARY + "_rowsNum"]: 3, // 视口显示行数
        [CONSTNAME.SUMMARY + "_header"]: [],
        [CONSTNAME.SUMMARY + "_body"]: {
          data: [], // 显示内容 单项为数组结构
          rate: [], // 占格数 单项为数字
        },

        /* 虚拟列表表格数量限制 */
        minRowsNum: 30, // 最少裁剪展示行数
      },
      mutations: mutations,
      actions: actions,
      modules: {},
      getters: getters,
    }
  );
  return store;
}

export default createStore;

